import React, { useState } from 'react';

import Button from '../../../components/ui/Button';

const CopyLinkButton = ({ url, label, variant = 'outline' }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e?.stopPropagation();
    try {
      await navigator.clipboard?.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  return (
    <Button
      variant={copied ? 'success' : variant}
      size="xs"
      onClick={handleCopy}
      iconName={copied ? 'Check' : 'Copy'}
      iconPosition="left"
      iconSize={12}
      className="whitespace-nowrap"
    >
      {copied ? 'Copied!' : label}
    </Button>
  );
};

export default CopyLinkButton;